<!--
 * @Author: DY
 * @Date: 2025-02-25 18:22:22
 * @LastEditTime: 2026-07-28 12:11:46
 * @Description: 附属产品出库表单【仓储管理-附属产品出库】
 * @FilePath: \ShiMoMobile\src\views\storage\accessoriesOutbound\form_hlj.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="accessoriesOutboundForm_hlj commonFormStyles">
            <HeaderNav header-title="附属产品出库表" left-icon-name="2" :extr="{ leftCallBack: swiperright }"></HeaderNav>
            <section>
                <van-tabs class="currencyTabsStyle" v-model="activeTab" animated :scrollspy="false">
                    <van-tab title="出库信息">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>出库信息</h5>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库单号"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.OutstockNumber"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="制单日期"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.BillDate"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field name="radio" label="出库类型" class="fieldRadio" :left-icon="require('@/assets/images/icons/icon_5@2x.png')">
                                        <template #input>
                                            <van-radio-group v-model="formData.OutstockType" direction="horizontal" :disabled="isDisabled || formData.OutstockCcpStocks.length > 0" ref="outstockTypeRadioGroup">
                                                <van-radio :name="1" checked-color="#ee0a24">
                                                    销售出库
                                                </van-radio>
                                                <van-radio :name="0" checked-color="#ee0a24">
                                                    短运出库
                                                </van-radio>
                                                <van-radio :name="4" checked-color="#ee0a24">
                                                    生产领用出库
                                                </van-radio>
                                            </van-radio-group>
                                        </template>
                                    </van-field>
                                </li>
                                <template v-if="formData.OutstockType == 1">
                                    <li>
                                        <van-field
                                            readonly
                                            label="来源单据编号"
                                            placeholder="选择来源单据"
                                            :disabled="isDisabled"
                                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                            v-model="formData.SourceNumber"
                                            @click="selectSource"
                                        ></van-field>
                                    </li>
                                    <li>
                                        <van-field
                                            disabled
                                            label="客户名称"
                                            placeholder="选择来源单据编号"
                                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                            v-model="formData.ClientNames"
                                        ></van-field>
                                    </li>
                                </template>
                                <li>
                                    <van-field
                                        readonly
                                        label="物料代码"
                                        :disabled="isDisabled || formData.OutstockType == 1"
                                        :placeholder="formData.OutstockType == 1 ? '选择来源单据编号' : '请选择物料'"
                                        :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                        v-model="formData.MaterialCodes"
                                        @click="selectMaterial"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="短描述"
                                        :placeholder="formData.OutstockType == 1 ? '选择来源单据编号' : '请选择物料'"
                                        :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                        v-model="formData.MaterialShortNames"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        :disabled="isDisabled"
                                        label="销售重量(吨)"
                                        placeholder="请输入销售重量"
                                        :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                                        v-model="formData.SalesWeight"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库总重量（吨）"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_44@2x.png')"
                                        v-model="formData.TotalOutstockWeight"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库人"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.OutstockUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="出库时间"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.OutstockTime"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="状态"
                                        placeholder="自动生成"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="Status"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        label="备注"
                                        type="textarea"
                                        :rows="4"
                                        :disabled="isDisabled"
                                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                        v-model="formData.Remarks"
                                    ></van-field>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="仓库明细">
                        <div class="formList">
                            <ul class="formItem">
                                <li class="formItemTitle">
                                    <h5>仓库明细</h5>
                                    <van-icon name="add" v-if="!isDisabled" @click="selectWarehouse"></van-icon>
                                </li>
                                <dl class="materialList" v-for="(item, index) in formData.OutstockCcpStocks" :key="`material_${index}`">
                                    <dt>
                                        <van-icon name="clear" v-if="!isDisabled" @click="deleteMaterial(index)"></van-icon>
                                        <p>{{ item.StockName }}</p>
                                    </dt>
                                    <dd>
                                        <div>
                                            <p>库位名称：</p>
                                            <input type="text" disabled v-model="item.GridName">
                                        </div>
                                        <div>
                                            <p>出库重量（吨）：</p>
                                            <input type="number" v-model="item.OutstockWeight" :disabled="isDisabled" @change="loadTotal">
                                        </div>
                                    </dd>
                                </dl>
                            </ul>
                        </div>
                    </van-tab>
                </van-tabs>
            </section>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button class="confirm" v-if="(formData.Id || '') != ''" @click="confirmRequest">
                        确认出库
                    </button>
                    <button class="confirm" @click="saveForm">
                        保存
                    </button>
                </template>
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import currencyFun from '@/assets/js/currencyFun/index.js';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    name: 'accessories-outbound-form-hlj',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/accessoriesOutbound') {
            this.$store.commit('noKeepAlive', 'accessories-outbound-form-hlj');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isDisabled: false,
            activeTab: 0,
            formData: {
                Id: '',
                OutstockNumber: '',
                BillDate: '',
                OutstockType: null,
                SaleOutstockType: 0,
                ProductCategory: 0,
                SourceId: '',
                SourceNumber: '',
                SalesWeight: null,
                MaterialCodes: '',
                MaterialShortNames: '',
                StockId: '',
                StockCode: '',
                StockName: '',
                GridId: '',
                GridCode: '',
                GridName: '',
                Status: 0,
                StatusName: '',
                TotalOutstockCount: 0,
                TotalOutstockWeight: 0,
                OutstockUserName: '',
                OutstockTime: '',
                OutstockDeptId: '',
                OutstockDeptName: '',
                Remarks: '',
                ClientNames: '',
                CarNumber: '',
                DeliveryNoticeId: '',
                OutstockCcpStocks: [],
            },
            Status: '',
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.source) {
            this.formData.SourceId = this.$route.params.source[0].id;
            this.formData.SourceNumber = this.$route.params.source[0].transport_number;
            this.formData.MaterialCodes = this.$route.params.source[0].material_codes || this.$route.params.source[0].material_code;
            this.formData.MaterialShortNames = this.$route.params.source[0].material_short_names || this.$route.params.source[0].material_short_name;
            this.formData.ClientNames = this.$route.params.source[0].client_names;
            this.formData.CarNumber = this.$route.params.source[0].car_number;
            this.resetWarehouseLocation();
        }
        if (this.$route.params.material) {
            this.formData.MaterialCodes = this.$route.params.material[0].all_material_code;
            this.formData.MaterialShortNames = this.$route.params.material[0].all_material_short_name;
            this.formData.MaterialUnit = this.$route.params.material[0].material_unit;
        }
        if (this.$route.params.warehouse) {
            this.$route.params.warehouse.forEach(item => {
                this.formData.OutstockCcpStocks.push({
                    StockId: item.stock_id,
                    StockCode: item.stock_code,
                    StockName: item.stock_name,
                    GridVolumeBefore: item.volume_current,
                    GridId: item.grid_id,
                    GridCode: item.grid_code,
                    GridName: item.grid_name,
                    OutstockWeight: 0,
                });
            });
            this.loadTotal();
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        async initpage() {
            const type = this.$route.params.type;
            if (type === 'new') {
                this.formData.BillDate = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
            }
            if (type === 'see') {
                this.isDisabled = true;
            }
            if (type === 'edit' || type === 'see') {
                this.formData = await this.getFormData(this.$route.params.id);
            }
            this.Status = this.loadStatus(this.formData.Status);

            // 确保在设置初始值后再绑定事件
            this.$nextTick(() => {
                this.$refs.outstockTypeRadioGroup.$on('change', this.selectOutboundType);
            });
        },

        loadStatus(nub) {
            const staus = ['未出库', '出库中', '已出库'];
            return staus[nub];
        },

        resetWarehouseLocation() {
            this.formData.DeliveryNoticeId = '';
            this.formData.StockId = '';
            this.formData.StockCode = '';
            this.formData.StockName = '';
            this.formData.GridId = '';
            this.formData.GridCode = '';
            this.formData.GridName = '';
        },

        selectOutboundType() {
            this.formData.SourceId = '';
            this.formData.SourceNumber = '';
            this.formData.MaterialCodes = '';
            this.formData.MaterialShortNames = '';
            this.resetWarehouseLocation();
        },

        selectSource() {
            if (this.isDisabled) {return;}
            if (!this.formData.OutstockType) {
                this.$toast('请选择出库类型');
                return;
            }
            this.$router.isBack = 2;
            if (this.formData.OutstockType === 1) {
                this.$router.replace({
                    name: 'selectListView',
                    params: {
                        pageTitle: '选择来源单据',
                        sourcePath: 'accessoriesOutboundForm_hlj',
                        listCode: 'accessory_choose_transport_truck',
                        callbackDataKey: 'source',
                        relationKey: 'id',
                        indexKey: 'page',
                        sizeKey: 'limit',
                        headerList:
                        [{
                            name: '汽运单号',
                            code: 'transport_number',
                            isTitle: true,
                        }, {
                            name: '运输方式',
                            code: 'transport_type_name',
                            icon: 'icon_11@2x',
                        }, {
                            name: '客户名称',
                            code: 'client_names',
                            icon: 'icon_1@2x',
                        }, {
                            name: '物料代码',
                            code: 'material_code',
                            icon: 'icon_28@2x',
                        }, {
                            name: '短描述',
                            code: 'material_short_name',
                            icon: 'icon_28@2x',
                        }, {
                            name: '发货数量（吨）',
                            code: 'delivery_weight_new',
                            icon: 'icon_6@2x',
                        }, {
                            name: '出库数量（吨）',
                            code: 'delivery_weight',
                            icon: 'icon_6@2x',
                        }, {
                            name: '车牌号',
                            code: 'car_number',
                            icon: 'icon_36@2x',
                        }, {
                            name: '司机',
                            code: 'driver_name',
                            icon: 'icon_8@2x',
                        }, {
                            name: '司机电话',
                            code: 'driver_phone',
                            icon: 'icon_9@2x',
                        }, {
                            name: '登记人',
                            code: 'creator',
                            icon: 'icon_8@2x',
                        }, {
                            name: '登记时间',
                            code: 'creation_time',
                            icon: 'icon_7@2x',
                        }, {
                            name: '备注',
                            code: 'remarks',
                            icon: 'icon_10@2x',
                        }],
                    },
                });
            }
        },
        // 选择物料
        selectMaterial() {
            if (this.formData.OutstockType === 1 || this.isDisabled) { return; }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择发货通知单',
                    sourcePath: 'accessoriesOutboundForm_hlj',
                    listCode: 'accessory_choose_material',
                    requestUrl: `/basicplatform/tabledata?transport_id=${this.formData.SourceId}`,
                    callbackDataKey: 'material',
                    relationKey: 'material_code',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '物料代码',
                        code: 'material_code',
                        isTitle: true,
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '长描述',
                        code: 'material_name',
                        icon: 'icon_10@2x',
                    }, {
                        name: '单位',
                        code: 'material_unit',
                        icon: 'icon_24@2x',
                    }],
                },
            });
        },

        selectWarehouse() {
            if ((this.formData.MaterialCodes || '') === '' ) {
                this.$toast.fail('请先选择物料！');
                return;
            }
            const selectedGrids = this.formData.OutstockCcpStocks.map(item => item.GridId).join(',');
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择仓库库位',
                    sourcePath: 'accessoriesOutboundForm_hlj',
                    requestUrl: `/basicplatform/tabledata?material_code=${this.formData.MaterialCodes}&selectedGrids=${selectedGrids}`,
                    listCode: 'accessory_choose_stock_grid',
                    callbackDataKey: 'warehouse',
                    relationKey: 'grid_code',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    type: 'checkbox',
                    pageSize: 100,
                    showTotal: true,
                    headerList: [{
                        name: '仓库编码',
                        code: 'stock_code',
                        isTitle: true,
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_44@2x',
                    }, {
                        name: '库位编号',
                        code: 'grid_code',
                        icon: 'icon_34@2x',
                    }, {
                        name: '库位名称',
                        code: 'grid_name',
                        icon: 'icon_32@2x',
                    }],
                },
            });
        },

        deleteMaterial(index) {
            this.formData.OutstockCcpStocks.splice(index, 1);
            this.loadTotal();
        },

        loadTotal() {
            this.formData.TotalOutstockCount = this.formData.OutstockCcpStocks.length;
            this.formData.TotalOutstockWeight = this.formData.OutstockCcpStocks.reduce((pre, cur) => {
                return NP.plus(pre, cur.OutstockWeight);
            }, 0);
        },

        async saveForm() {
            if (this.formData.OutstockType !== 4 && this.formData.SalesWeight === '') {
                this.$toast.fail('请输入销售重量！');
                return;
            }
            if ((this.formData.OutstockCcpStocks || []).length === 0) {
                this.$toast.fail('请选择仓库库位！');
                return;
            }
            const requestData = {
                Id: this.formData.Id,
                OutstockNumber: this.formData.OutstockNumber,
                OutstockType: this.formData.OutstockType,
                SaleOutstockType: this.formData.SaleOutstockType,
                SourceId: this.formData.SourceId,
                SourceNumber: this.formData.SourceNumber,
                SalesWeight: this.formData.SalesWeight,
                SourceContractNos: this.formData.SourceContractNos,
                MaterialCodes: this.formData.MaterialCodes,
                MaterialShortNames: this.formData.MaterialShortNames,
                TotalOutstockWeight: this.formData.TotalOutstockWeight,
                ClientNames: this.formData.ClientNames,
                CarNumber: '',
                Status: 0,
                OutstockCcpStocks: this.formData.OutstockCcpStocks,
            };
            const res = await this.saveFormData(requestData);
            if (res) {
                this.formData = await this.getFormData(res.Id);
                this.$toast.success('保存成功。');
            }
        },

        async confirmRequest() {
            this.$toast.loading({ overlay: true, duration: 0 });
            const res = await this.submitFormData(this.formData.Id);
            if (res) {
                this.$toast.success('确认成功。');
                this.closeAllocationForm();
            }
            this.$toast.clear();
        },

        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'accessoriesOutbound',
                params: {
                    saveCallback: true,
                },
            });
        },
        getFormData(id) {
            return this.$axios.$get(`/interfaceApi/sale/outstock/accessory_outstock_ccp_single?id=${id}`);
        },
        saveFormData(requestData) {
            return this.$axios.$post('/interfaceApi/sale/outstock/accessory_outstock_ccp_save', requestData);
        },
        submitFormData(id) {
            return this.$axios.$get(`/interfaceApi/sale/outstock/accessory_outstock_ccp_confirm?id=${id}`);
        },
    },
    beforeDestroy() {},
};
</script>
<style lang="stylus">
.accessoriesOutboundForm_hlj
    background #F0F0F0
    section
        height 0
        flex 1
    .formList
        padding 10rpx
        .formItem
            background #fff
            .formItemTitle
                .scanCodeButton
                    color #E93743
                    font-size 12rpx
                    margin-right auto
                    margin-left 10rpx
                    width: 52rpx;
                    height: 26rpx;
                    line-height 24rpx;
                    background: rgba(233,55,67,0.1);
                    border-radius: 2rpx;
                    border: 1px solid rgba(233,55,67,0.2)
        .materialList
            margin 10rpx
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
            border-radius: 4rpx;
            overflow hidden
            dt
                height 42rpx
                background: #F8F8F8;
                border-bottom: 1px solid #E7E6E6;
                display flex
                align-items center
                padding 0 14rpx
                .van-icon
                    color #E93543
                    font-size 16rpx
                    margin-right 10rpx
                // h5
                //     font-size 16rpx
                //     color #e93743
                p
                    // margin-left auto
                    color #e93743
            dd
                padding 7rpx
                display flex
                flex-wrap wrap
                div
                    width 50%
                    padding 7rpx
                    p
                        font-size 14rpx
                        color #626262
                        margin-bottom 6rpx
                    input
                        width 100%
                        height: 40px;
                        padding 0 6rpx
                        background: #FAFBFE;
                        border-radius: 4px;
                        border: 1px solid #ADC7E0;
                        &[disabled]
                            background: #F8F8F8
                            border-color #D7D7D7
                            color rgba(98, 98, 98, 0.7)
                            -webkit-text-fill-color rgba(98, 98, 98, 0.7)
    .confirmPopUp
        width 90%
        border-radius 8rpx
        .van-dialog__header
            font-size 16rpx
            color #E93543
            padding 14rpx 0
            border-bottom 1px solid rgba(231, 230, 230, 1)
            background: linear-gradient( 180deg, #FFF4F2 0%, #FFFFFF 100%);
        .van-dialog__content
            padding 10rpx
            max-height: 60vh;
            overflow-y: auto;
            table
                width 100%
                border-collapse collapse;
                box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
                border-radius: 4px;
                border: 1px solid #E7E6E6;
                overflow: hidden;
                th,td
                    border 1px solid #E7E6E6
                    font-size 14rpx
                    text-align center
                    height 36rpx
</style>

